import { motion, useReducedMotion } from "framer-motion";
import posts from "../../data/posts.json";
import { withBase } from "../../siteInfo";
import Reveal from "../../motion/Reveal";

const BlogTeaser = () => {
  const reduce = useReducedMotion();
  const featured = [];
  const seen = new Set();
  posts.forEach((post) => {
    if (seen.has(post.category) || featured.length >= 6) return;
    seen.add(post.category);
    featured.push(post);
  });

  return (
    <section className="section" id="guides">
      <div className="wrap">
        <Reveal className="section-head section-head-row">
          <div>
            <p className="kicker">
              <span>04</span> Health library
            </p>
            <h2>Guides for the problems families actually bring in.</h2>
            <p>
              {posts.length} articles on blood pressure, sugar, pregnancy, children, bones,
              monsoon illness, and when to stop waiting. They explain. They do not replace a visit.
            </p>
          </div>
          <a className="btn btn-line" href={withBase("/blog/")}>
            All {posts.length} guides
          </a>
        </Reveal>
        <div className="post-grid">
          {featured.map((post, index) => (
            <motion.a
              className="post-card"
              href={withBase(`/blog/${post.slug}/`)}
              key={post.slug}
              initial={reduce ? false : { opacity: 0, y: 18 }}
              whileInView={reduce ? undefined : { opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "0px 0px -10% 0px" }}
              transition={{ duration: 0.6, delay: reduce ? 0 : index * 0.05 }}
              whileHover={reduce ? undefined : { y: -4 }}
            >
              <img src={withBase(`/images/${post.image}`)} alt="" />
              <div>
                <div className="cat">{post.category}</div>
                <h3>{post.title}</h3>
                <p>{post.description}</p>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogTeaser;
